// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9f0a6ae2","952":"1d272a65"}[chunkId] + ".chunk.js";
};